import { FC } from "react";

const NLFlag: FC = () => (
<svg xmlns="http://www.w3.org/2000/svg" id="flag-icons-nl" viewBox="0 0 640 480" height="18">
<path fill="#ae1c28" d="M0 0h640v160H0z"/>
<path fill="#fff" d="M0 160h640v160H0z"/>
<path fill="#21468b" d="M0 320h640v160H0z"/>
</svg>
);

export default NLFlag;
